import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SearchUserAccountsResponse } from '../models/search-user-accounts-response.model';
import { GetUserAccountByIdResponse } from '../models/get-user-account-by-id-response.model';
import { UploadProfileResponse } from '../models/upload-profile-response.model';
import { UpdateUserAccountsResponse } from '../models/update-user-accounts-response.model';
import { UserAccountsResetPasswordResponse } from '../models/user-accounts-reset-password-response.model';
import { ImportsUserAccountsResponse } from '../models/imports-user-accounts.model';
import { CreateUserAccountsResponse } from '../models/create-user-accounts-response.model';
import { map } from 'rxjs';
import { UserAccountChangePasswordResponse } from '../models/user-account-chenge-password-response.model';
import { BaseResponseModel } from '@/core/models/baseModel';
import { BranchSelectResponse } from '@/core/models/select.model';

@Injectable({
    providedIn: 'root'
})
export class UserAccountsApi {
    http = inject(HttpClient);
    private baseUrl = `${environment.apiUrl}`;
    headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    SearchUserAccounts(search: string, page: number, pageSize: number) {
        return this.http.post<SearchUserAccountsResponse>(`${this.baseUrl}/search`, { search, page, pageSize }, this.headerOptions);
    }

    GetUserAccountById(userAccountId: string) {
        return this.http.get<GetUserAccountByIdResponse>(`${this.baseUrl}/user/${userAccountId}`, this.headerOptions);
    }

    UploadUserAvatar(file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<UploadProfileResponse>(`${this.baseUrl}/upload-account-profile`, formData);
    }

    UpdateUserAccount(userAccountId: string, fullName: string, empCode: string, phone: string, email: string, departmentId: string, roleId: string, positionId: string, avatarUrl: string, updateBy: string, updateByUserName: string) {
        return this.http.post<UpdateUserAccountsResponse>(`${this.baseUrl}/update`, { userAccountId, fullName, empCode, phone, email, departmentId, roleId, positionId, avatarUrl, updateBy, updateByUserName }, this.headerOptions);
    }

    UserAccountsResetPassword(userAccountId: string, resetBy: string, userNameRestBy: string) {
        return this.http.post<UserAccountsResetPasswordResponse>(`${this.baseUrl}/reset-password`, { userAccountId, resetBy, userNameRestBy }, this.headerOptions);
    }

    ImportsUserAccounts(actionBy: string, actionUserName: string) {
        return this.http.post<ImportsUserAccountsResponse>(`${this.baseUrl}/import`, { actionBy, actionUserName }, this.headerOptions);
    }

    CreateUserAccount(fullName: string, empCode: string, phone: string, email: string, departmentId: string, roleId: string, positionId: string, avatarUrl: string, createdBy: string, createdByUserName: string) {
        return this.http.post<CreateUserAccountsResponse>(`${this.baseUrl}/create`, { fullName, empCode, phone, email, departmentId, roleId, positionId, avatarUrl, createdBy, createdByUserName }, this.headerOptions);
    }

    CheckUserAccountFullName(fullName: string) {
        return this.http.post<{ isRegister: boolean }>(`${this.baseUrl}/check-full-name-register`, { fullName }, this.headerOptions).pipe(map((res) => res.isRegister));
    }

    CheckUserAccountEmpCode(empCode: string) {
        return this.http.post<{ isRegister: boolean }>(`${this.baseUrl}/check-emp-code-register`, { empCode }, this.headerOptions).pipe(map((res) => res.isRegister));
    }

    CheckUserAccountEmail(email: string) {
        return this.http.post<{ isRegister: boolean }>(`${this.baseUrl}/check-email-register`, { email }, this.headerOptions).pipe(map((res) => res.isRegister));
    }

    UserAccountChangePassword(userAccountId: string, currentPassword: string, newPassword: string, confirmNewPassword: string) {
        return this.http.post<UserAccountChangePasswordResponse>(`${this.baseUrl}/change-password`, { userAccountId, currentPassword, newPassword, confirmNewPassword }, this.headerOptions);
    }

    ResetPassword(userAccountId: string, resetBy: string, userNameResetBy: string) {
        return this.http.post<UserAccountsResetPasswordResponse>(`${this.baseUrl}/reset-password`, { userAccountId, resetBy, userNameResetBy }, this.headerOptions);
    }

    GetSelectBranchListByUserId(userId: string) {
        return this.http.get<BranchSelectResponse>(`${this.baseUrl}/user/get-select-branch-by-user/${userId}`, this.headerOptions);
    }

}
